export default "__VITE_ASSET__dNkoy6HR__"